import type {CpcBuyStep} from 'modules/Cpc/Buy/types';

import {cn} from '@ds/helpers';

type BuyProgressProps = {
  steps: CpcBuyStep[];
  currentStep: CpcBuyStep;
};

const BuyProgress: React.FC<BuyProgressProps> = ({steps, currentStep}) => {
  return (
    <div
      className="flex h-10 gap-1.25 px-2.5 py-4"
      role="progressbar"
      aria-label="مراحل ایجاد کمپین کلیک"
      aria-valuemin={1}
      aria-valuemax={steps.length}
      aria-valuenow={currentStep.id}
    >
      {steps.map((step) => (
        <span
          key={step.id}
          className={cn('h-1.75 flex-1 bg-gray-03', currentStep.id >= step.id && 'bg-orange-main')}
          aria-hidden
        />
      ))}
    </div>
  );
};

export default BuyProgress;
